/** @jsxImportSource @emotion/react */
import * as React from 'react';
import * as Icons from '@zip/icons';
import * as styles from 'modules/activation/dashboard/ActivationDashboard.styles';

export type StepStatus = 'completed' | 'active' | 'upcoming';

type StepIndicatorProps = {
  id: number;
  status: StepStatus;
};

export function StepIndicator({
  id,
  status,
}: StepIndicatorProps): React.JSX.Element {
  if (status === 'completed') {
    return (
      <span
        aria-label={`Step ${id} completed`}
        css={styles.stepIndicator(status)}
      >
        <Icons.CheckCircle aria-hidden="true" focusable="false" />
      </span>
    );
  }

  return (
    <span
      aria-label={`Step ${id} ${status}`}
      css={styles.stepIndicator(status)}
    >
      <span className="body3" css={styles.numberIndicator}>
        {id}
      </span>
    </span>
  );
}
